// components/SmartRedirect/index.jsx
import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { Context } from '../context/Contex';

export default function SmartRedirect() {
    const { hasPermission, permissionsLoading } = useContext(Context);

    if (permissionsLoading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                fontSize: '1.2rem',
                color: '#666',
                flexDirection: 'column',
                gap: '1rem'
            }}>
                <div className="spinner" style={{
                    width: '40px',
                    height: '40px',
                    border: '4px solid #f3f3f3',
                    borderTop: '4px solid #3498db',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                }}></div>
                <div>Redirecionando...</div>
                <style>{`
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}</style>
            </div>
        );
    }

    // Prioridade: Dashboard → Analytics → Load → Export → Notifications → Profile
    if (hasPermission('dashBoard')) {
        return <Navigate to="/dashboard" replace />;
    }
    
    if (hasPermission('analytics')) {
        return <Navigate to="/analytics" replace />;
    }
    
    if (hasPermission('upload')) {
        return <Navigate to="/load" replace />;
    }
    
    if (hasPermission('export')) {
        return <Navigate to="/export" replace />;
    }
    
    if (hasPermission('notifications')) {
        return <Navigate to="/notifications" replace />;
    }
    
    if (hasPermission('settings')) {
        return <Navigate to="/settings" replace />;
    }

    if (hasPermission('ticketUpdates')) {
        return <Navigate to="/ticketUpdates" replace />;
    }


    // Se não tem nenhuma permissão, vai pro perfil
    return <Navigate to="/profile" replace />;
}